import { useSegmentTracking } from 'Common/segment/useSegment';

const HomepageGACategory = 'Homepage';

const useHomepageTracking = () => {
    const { track } = useSegmentTracking();

    const trackSliderImpression = (label: string) =>
        track('[SEGMENT-TEST] Homepage sliders impression', {
            category: HomepageGACategory,
            label,
        });

    const trackBestSellerSliderImpression = () => trackSliderImpression('Best sellers slider impression');
    const trackCategorySliderImpression = () => trackSliderImpression('Categories slider impression');

    const trackUGCGalleryBanner = {
        click: () =>
            track('[SEGMENT-TEST] User Generated Gallery Banner Click', {
                category: HomepageGACategory,
            }),
        impression: () =>
            track('[SEGMENT-TEST] User Generated Gallery Banner Impression', {
                category: HomepageGACategory,
            }),
    };

    return {
        trackUGCGalleryBanner,
        trackBestSellerSliderImpression,
        trackCategorySliderImpression,
    };
};

export default useHomepageTracking;
